import HumanPractices from './HumanPractices'

export default HumanPractices
